import { faChevronRight, faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PlayBtn from '../../../main/components/PlayBtn';
const PostCard = ({ post }) => {
    return (
        <div className="m-2 mb-5 ">
            <div className="card post-card-container  position-relative">
                <img src={post?.logo?.url} className="img-fluid px-3 pb-3 pt-4" alt="..."></img>
                <div className="card-body mx-1">
                    <div className="d-flex position-absolute top-0 end-0 mt-2  justify-content-end pe-3 pinter-cursor  secondary-text">

                        <PlayBtn link={post?.video_link && post?.video_link} />

                    </div>
                    <h6 className="">{post?.title1[0]?.text}</h6>
                    <p className="text-muted">{post?.description1[0]?.text.length > 70 ? ` ${post?.description1[0]?.text.slice(0, 70)} .....` : post?.description1[0]?.text}</p>
                </div>
                <div className="card-footer d-flex justify-content-end">
                    <a target="_blank" href={post?.external_link[0].text} className="news-read-more"> Read Story  <span className="ms-1"><FontAwesomeIcon icon={faChevronRight} /></span></a>

                </div>
            </div>
        </div>
    );
};

export default PostCard;